import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@techsoftware/happay-widgets/FontIcon';

import PhotoIdentityCorrect from '../../../assets/images/kyc-guideline/photo-identity-correct.png';
import PhotoIdentityWrong from '../../../assets/images/kyc-guideline/photo-identity-wrong.png';

import AadhaarFrontCorrect from '../../../assets/images/kyc-guideline/aadhaar-front-correct.png';
import AadhaarFrontWrong from '../../../assets/images/kyc-guideline/aadhaar-front-wrong.png';
import AadhaarBackCorrect from '../../../assets/images/kyc-guideline/aadhaar-back-correct.png';
import AadhaarBackWrong from '../../../assets/images/kyc-guideline/aadhaar-back-wrong.png';

import PanFrontCorrect from '../../../assets/images/kyc-guideline/pan-front-correct.png';
import PanFrontWrong from '../../../assets/images/kyc-guideline/pan-front-wrong.png';

import DrivingLicenceFrontCorrect from '../../../assets/images/kyc-guideline/driving-licence-front-correct.png';
import DrivingLicenceBackCorrect from '../../../assets/images/kyc-guideline/driving-licence-back-correct.png';
import DrivingLicenceFrontWrong from '../../../assets/images/kyc-guideline/driving-licence-front-wrong.png';
import DrivingLicenceBackWrong from '../../../assets/images/kyc-guideline/driving-licence-back-wrong.png';

import VoterFrontCorrect from '../../../assets/images/kyc-guideline/voter-front-correct.png';
import VoterBackCorrect from '../../../assets/images/kyc-guideline/voter-back-correct.png';
import VoterFrontWrong from '../../../assets/images/kyc-guideline/voter-front-wrong.png';
import VoterBackWrong from '../../../assets/images/kyc-guideline/voter-back-wrong.png';

import PassportFrontCorrect from '../../../assets/images/kyc-guideline/passport-front-correct.png';
import PassportBackCorrect from '../../../assets/images/kyc-guideline/passport-back-correct.png';
import PassportFrontWrong from '../../../assets/images/kyc-guideline/passport-front-wrong.png';
import PassportBackWrong from '../../../assets/images/kyc-guideline/passport-back-wrong.png';

const GuideLineCard = props => {
  const getImgPath = type => {
    const imgPathObj = {
      PhotoIdentityCorrect,
      PhotoIdentityWrong,
      AadhaarFrontCorrect,
      AadhaarFrontWrong,
      AadhaarBackCorrect,
      AadhaarBackWrong,
      PanFrontCorrect,
      PanFrontWrong,
      DrivingLicenceFrontCorrect,
      DrivingLicenceBackCorrect,
      DrivingLicenceFrontWrong,
      DrivingLicenceBackWrong,
      VoterFrontCorrect,
      VoterBackCorrect,
      VoterFrontWrong,
      VoterBackWrong,
      PassportFrontCorrect,
      PassportBackCorrect,
      PassportFrontWrong,
      PassportBackWrong,
    };
    return imgPathObj[type];
  };

  const renderImg = item => {
    const horizontalImgs = ['Aadhaar Card', 'PAN Card', 'Driving Licence'];

    return (
      <div className="guideLineImgContainer">
        <div
          className={
            horizontalImgs.includes(item.docType)
              ? 'horizontalImgBoxCorrect'
              : 'verticalImgBoxCorrect'
          }
        >
          <img
            alt={item.docType}
            className={
              horizontalImgs.includes(item.docType)
                ? 'horizontalImg'
                : 'verticalImg'
            }
            src={getImgPath(item.correctImg)}
          />
          <Icon
            type="tick-fill"
            active
            activeClass="iconFont"
            className={`status green 
                        ${
      horizontalImgs.includes(item.docType)
        ? 'horizontalIconSize'
        : 'verticalIconSize'
      }`}
          />
        </div>
        <div
          className={
            horizontalImgs.includes(item.docType)
              ? 'horizontalImgSeprator'
              : 'verticalImgSeprator'
          }
        ></div>
        <div
          className={
            horizontalImgs.includes(item.docType)
              ? 'horizontalImgBoxWrong'
              : 'verticalImgBoxWrong'
          }
        >
          <img
            alt={item.docType}
            className={
              horizontalImgs.includes(item.docType)
                ? 'horizontalImg'
                : 'verticalImg'
            }
            src={getImgPath(item.wrongImg)}
          />
          <Icon
            type="cross-fill"
            active
            activeClass="iconFont"
            className={`status red 
                                ${
      horizontalImgs.includes(item.docType)
        ? 'horizontalIconSize'
        : 'verticalIconSize'
      }`}
          />
        </div>
      </div>
    );
  };

  const { cardData = [] } = props;

  return (
    <div className="guideLineCardParentContainer">
      {cardData.length > 0 &&
        cardData.map((item, index) => (
          <div
            key={`${item.title}`}
            className={`guideLineCardContainer ${
              item.title === 'back' ? 'guideLineCardContainerBack' : ''
            }`}
          >
            <div className="guideLineDocImgTitle">{item.title}</div>
            {renderImg(item)}
            <div className="horizontalListItem">
              {item.tips.length > 0 &&
                item.tips.map(tip => <li key={`${item.title}`}>{tip}</li>)}
            </div>
          </div>
        ))}
    </div>
  );
};

GuideLineCard.propTypes = {
  cardData: PropTypes.array,
};

export default GuideLineCard;
